module.exports = __webpack_public_path__ + "static/Bild Seite 2 - Verkäuferin-83a3a08fdab9d9a25eba51ec1d83e327.jpg";